export default __webpack_public_path__ + "static/media/picsure_logo_small.93ae9e4e.svg";